export const MODAL_OPEN = 'modal/OPEN';

export const MODAL_CLOSE = 'modal/CLOSE';

export const MODAL_CLOSE_ALL = 'modal/CLOSE_ALL';
